import { createSelector } from '@reduxjs/toolkit'
import type { RootState } from 'domains/store'

export const selectVisibility = createSelector(
  ({ visibility }: RootState) => visibility,
  (state) => state.visibility,
)

export const selectShowInlineView = createSelector(
  ({ visibility }: RootState) => visibility,
  (state) => state.showInlineView,
)

export const selectShowContinueChat = createSelector(
  ({ visibility }: RootState) => visibility,
  (state) => state.showContinueChat,
)

export const selectShowPreChat = createSelector(
  ({ visibility }: RootState) => visibility,
  (state) => state.showPreChat,
)

export const selectSetInputFocus = createSelector(
  ({ visibility }: RootState) => visibility,
  (state) => state.setInputFocus,
)
